import { render, staticRenderFns } from "./jqg.vue?vue&type=template&id=52804576&scoped=true&"
import script from "./jqg.vue?vue&type=script&lang=js&"
export * from "./jqg.vue?vue&type=script&lang=js&"
import style0 from "./jqg.vue?vue&type=style&index=0&id=52804576&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52804576",
  null
  
)

export default component.exports